import { useNavigate } from 'react-router-dom';
import { KeyRound, LogOut, User as UserIcon } from 'lucide-react';
import { Dropdown, DropdownItem } from '@/components/ui/Dropdown';
import { Avatar } from '@/components/ui/Avatar';
import { useAuth } from '@/hooks/useAuth';

/** Portal variant of ProfileMenu — same shell, routes to /portal/profile instead of /profile (a client-role user never renders the staff route tree). */
export function PortalProfileMenu() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  if (!user) {
    return null;
  }

  const fullName = `${user.first_name} ${user.last_name ?? ''}`.trim();

  return (
    <Dropdown
      width={240}
      trigger={({ onClick, isOpen }) => (
        <button
          type="button"
          onClick={onClick}
          className={`flex items-center gap-2 rounded-full p-0.5 transition-colors ${isOpen ? 'ring-2 ring-brand-500/40' : ''}`}
          aria-label="Open profile menu"
        >
          <Avatar src={user.avatar_url} name={fullName} size={32} />
        </button>
      )}
    >
      {(close) => (
        <div className="flex flex-col gap-0.5">
          <div className="flex items-center gap-3 px-3 py-2">
            <Avatar src={user.avatar_url} name={fullName} size={36} />
            <div className="min-w-0">
              <p className="truncate text-sm font-semibold text-gray-900 dark:text-gray-100">{fullName}</p>
              <p className="truncate text-xs text-gray-400">{user.email}</p>
            </div>
          </div>
          <div className="my-1 border-t border-gray-100 dark:border-gray-800" />

          <DropdownItem icon={UserIcon} label="View profile" onClick={() => { navigate('/portal/profile'); close(); }} />
          <DropdownItem icon={KeyRound} label="Change password" onClick={() => { navigate('/portal/profile/password'); close(); }} />

          <div className="my-1 border-t border-gray-100 dark:border-gray-800" />
          <DropdownItem icon={LogOut} label="Log out" danger onClick={() => { void logout(); close(); }} />
        </div>
      )}
    </Dropdown>
  );
}
